import { z } from 'zod';

export const vehicleGroupSchema = z.object({
  vehicleGroupId: z.number().min(0),
  vehicleGroupName: z.string().min(1),
  numberOfVehicles: z.number().optional(),
  numberOfRoutingProfiles: z.number().optional(),
  oorEmail: z.string().nullable().optional(),
  oorEmailIsEnabled: z.boolean().optional(),
});

export const vehicleGroupsSchema = z.array(vehicleGroupSchema);

export type VehicleGroup = z.infer<typeof vehicleGroupSchema>;

export type VehicleGroups = z.infer<typeof vehicleGroupsSchema>;
